import { Injectable } from '@angular/core';

import { BetslipUpsellConfig } from '@frontend/sports/common/client-config-data-access';
import { BetslipDisplayMode } from '@frontend/sports/types/components/bet-placement';

import { IBetslipState } from '../../../base/store/state';
import { BetslipType } from '../../../core/betslip-type';
import { isErrorComboPrevention } from '../../validation/services/utils/betslip-errors-utils';

@Injectable()
export class UpsellBetTypeService {
    constructor(private betslipUpsellConfig: BetslipUpsellConfig) {}

    showUpsellForSingle(picksCount: number, state: IBetslipState): boolean {
        return (
            (state.types.base.currentSelectedType === BetslipType.Single || state.base.displayMode === BetslipDisplayMode.Linear) &&
            this.betslipUpsellConfig.isEnabledForSingle &&
            picksCount === 1
        );
    }

    showUpsellForMulti(picksCount: number, state: IBetslipState): boolean {
        return (
            picksCount >= 2 &&
            this.betslipUpsellConfig.isEnabledForMulti &&
            (state.base.displayMode === BetslipDisplayMode.Linear ||
                (state.types.base.currentSelectedType === BetslipType.Combo &&
                    !Object.values(state.errors.pickErrors[BetslipType.Combo])
                        .flatMap((errors) => errors)
                        .some((e) => isErrorComboPrevention(e))))
        );
    }
}
